<template>
  <div class="wrapper">
    <div class="navbar">
      <img class="logo" src="@/assets/img/logo.svg" alt width="144px" height="60px" />

      <nav>
        <a href="#" class="hamburger" @click="makeReactive = !makeReactive">&#9776;</a>
        <div class="desktop">
          <router-link :to="{ name: 'about' }">About</router-link>
          <router-link :to="{ name: 'home' }" @click.native="$emit('refresh')">Home</router-link>
        </div>
      </nav>
    </div>
    <div class="darken-wrapper" v-show="makeReactive" @click="makeReactive=false">
      <div class="reactive-menu" v-show="makeReactive">
        <router-link :to="{ name: 'home' }" @click.native="$emit('refresh')">Home</router-link>
        <router-link :to="{ name: 'about' }">About</router-link>
        <a href="https://www.becketal.com/" target="_blank" rel="noopener">our site</a>
        <a href="https://medium.com/beck-et-al" target="_blank" rel="noopener">#our blog</a>
        <div class="social">
          <a
            href="https://www.linkedin.com/company/beck-et-al.-services/"
            target="_blank"
            rel="noopener"
          >
            <div class="linkedin">in</div>
          </a>
          <a href="https://twitter.com/Beck_et_al" target="_blank" rel="noopener">
            <img class="twitter" src="../assets/img/twitter.svg" alt height="30px" />
          </a>
          <a
            href="https://www.facebook.com/pages/Beck-et-al-Services/127672825067"
            target="_blank"
            rel="noopener"
          >
            <img class="facebook" src="../assets/img/facebook.svg" alt height="40px" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data: () => {
    return {
      makeReactive: false
    };
  }
};
</script>
<style lang="scss" scoped>
.wrapper {
  position: fixed;
  margin: 0;
  padding: 0;
  width: 100%;
  z-index: 100;
}
.navbar {
  display: grid;
  grid-template-columns: 1fr 5fr 1fr;
  padding: 10px 0;
  margin: 5px 0;
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 10px;
  nav {
    position: relative;
    grid-column: 2;
    grid-row: 1;
    max-width: 100vw;
    .hamburger {
      display: none;
      position: absolute;
      margin-right: 20px;
      font-size: 30px;
    }
    a {
      float: right;
      padding-top: 20px;
      text-decoration: none;
      font-size: 20px;
      color: $primary;
      margin-left: 20px;
    }
    .desktop {
      a::after {
        content: "";
        position: relative;
        width: 0;
        height: 5px;
        display: block;
        margin-top: 5px;
        left: -10%;
        right: 0;
        background: $primary;
        transition: width 0.2s ease;
        -webkit-transition: width 0.2s ease;
      }
      a:hover::after {
        width: 120%;
        left: -10%;
        background: $primary;
      }
    }
  }
}
.darken-wrapper {
  display: none;
}
.logo {
  grid-column: 2;
  grid-row: 1;
}

@media screen and (max-width: 700px) {
  .navbar {
    padding: 0;
    margin: 0;
    grid-template-columns: auto;
    .logo {
      grid-column: 1;
    }
    nav {
      .hamburger {
        display: block;
        position: relative;
      }
      .desktop {
        display: none;
        position: absolute;
      }
    }
  }
  .darken-wrapper {
    display: block;
    z-index: 50;
    position: absolute;
    background-color: rgba(0, 0, 0, 0.8);
    width: 100vw;
    height: 100vh;
    .reactive-menu {
      position: relative;
      top: 5px;
      z-index: 99;
      left: 0;
      width: 100vw;
      padding: 20px 0;
      background-color: #fff;
      a {
        display: block;
        margin-top: 10px;
        margin-bottom: 20px;
        padding: 20px;
        text-decoration: none;
        color: $primary;
        font-size: 20px;
      }
      .social {
        display: block;
        position: relative;
        left: 10px;
        a {
          color: $primary;
          display: inline-block;
          text-decoration: none;
        }
      }
      .twitter {
        position: relative;
        bottom: 3px;
      }
      .linkedin {
        position: relative;
        margin: 0;
        padding: 0;
        bottom: 7px;
        right: 10px;
        letter-spacing: normal;
        font-weight: bold;
        font-size: 30px;
        display: inline-block;
      }
    }
  }
}

@media screen and (min-width: 1600px) {
  .navbar {
    grid-template-columns: 1fr 2fr 1fr;
  }
}
</style>

